import { Button } from '@mui/material';

import { FSimpleDialog, F_SIMPLE_DIALOG_VARIANT } from '../../../../components/baseV2';
import { ConcludeErrorsDialog, QUESTIONNAIRE_FOOTER_BUTTON_SX } from '../../common';
import { useFormReadOnly } from '../../../common';
import { useConcludeIntakeQuestionnaire } from '../hooks';

export default function ConcludeIntakeAction() {
  const {
    isDialogOpen,
    isSubmitting,
    isSaving,
    errorPageLabels,
    openDialog,
    closeDialog,
    confirmConclude,
  } = useConcludeIntakeQuestionnaire();
  const readOnly = useFormReadOnly();
  const hasErrors = errorPageLabels.length > 0;

  // A read-only questionnaire is already concluded or is being viewed by a non-guardian —
  // in neither case should it be concludable.
  if (readOnly) return null;

  return (
    <>
      <Button sx={QUESTIONNAIRE_FOOTER_BUTTON_SX} variant="contained" onClick={openDialog}>
        Conclude
      </Button>
      {hasErrors ? (
        <ConcludeErrorsDialog
          open={isDialogOpen}
          pageLabels={errorPageLabels}
          onClose={closeDialog}
        />
      ) : (
        <FSimpleDialog
          open={isDialogOpen}
          onClose={closeDialog}
          variant={F_SIMPLE_DIALOG_VARIANT.WARNING}
          title="Are you sure you want to conclude?"
          cancelText="Cancel"
          onCancel={closeDialog}
          actionText="Conclude"
          onAction={confirmConclude}
          loading={isSubmitting || isSaving}
        >
          Once you conclude this clinical intake, you will not be able to make any further changes.
        </FSimpleDialog>
      )}
    </>
  );
}
